import { createSlice } from "@reduxjs/toolkit";

import {getCategoryList, getCountryList, getLanguages, getTags} from "redux/actions/app";

export type AlertTypes = "error" | "warning" | "info" | "success";
export type Language = "en" | "jp";

export interface IApp {
  countryList: Array<any>;
  categoryList: Array<any>;
  alert: {
    isOpen: boolean;
    type: AlertTypes;
    children: any;
  };
  isOpenUseEDUBAModal: boolean;
  bottomBarAction: number;
  loading: boolean;
  language: Language;
  languageList: Array<any>;
  tagList:string[]
}

const initial: IApp = {
  countryList: [],
  categoryList: [],
  alert: {
    isOpen: false,
    type: "success",
    children: null,
  },
  isOpenUseEDUBAModal: false,
  bottomBarAction: 0,
  loading: false,
  language: "jp",
  languageList: [],
  tagList:[]
};

export const appSlice = createSlice({
  name: "app",
  initialState: initial,
  reducers: {
    triggerAlert(state, action) {
      state.alert = {
        isOpen: true,
        type: action?.payload?.type,
        children: action?.payload?.children,
      };
    },
    closeAlert(state) {
      state.alert = {
        isOpen: false,
        type: "success",
        children: null,
      };
    },
    setBottomBarAction(state, action) {
      state.bottomBarAction = action.payload;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setIsOpenUseEDUBAModal(state, action) {
      state.isOpenUseEDUBAModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCategoryList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCategoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryList = action.payload;
    });
    builder.addCase(getCategoryList.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getCountryList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCountryList.fulfilled, (state, action) => {
      state.loading = false;
      state.countryList = action.payload;
    });
    builder.addCase(getCountryList.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getLanguages.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLanguages.fulfilled, (state, action) => {
      state.loading = false;
      state.languageList = action.payload;
    });
    builder.addCase(getLanguages.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getTags.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getTags.fulfilled, (state, action) => {
      state.loading = false;
      state.tagList = action.payload;
    });
    builder.addCase(getTags.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  closeAlert,
  triggerAlert,
  setBottomBarAction,
  setLanguage,
  setIsOpenUseEDUBAModal,
} = appSlice.actions;

export default appSlice.reducer;
